import api from './axios';

// Get all users (filtered by role if provided)
export const getUsers = async (role = null, options = {}) => {
  const params = new URLSearchParams();
  if (role) params.set('role', role);
  if (options.assignmentTenantId != null && options.assignmentTenantId !== '') {
    params.set('assignment_tenant_id', String(options.assignmentTenantId));
  }
  const q = params.toString();
  const response = await api.get(`/users${q ? `?${q}` : ''}`);
  return response.data;
};

/** Minimal tenant list for configuring extra ticket tenants per agent (admin / super_admin) */
export const getTenantTicketAccessOptions = async () => {
  const response = await api.get('/users/tenant-options/ticket-access');
  return response.data;
};

// Get single user
export const getUser = async (userId) => {
  const response = await api.get(`/users/${userId}`);
  return response.data;
};

// Update own profile
export const updateProfile = async (profileData) => {
  const response = await api.put('/users/me', profileData);
  return response.data;
};

// Create new user (Admin only)
export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

// Bulk create users (Admin only)
export const bulkCreateUsers = async (users) => {
  const response = await api.post('/users/bulk-create', { users });
  return response.data;
};

// Update user (Admin only)
export const updateUser = async (userId, userData) => {
  const response = await api.put(`/users/${userId}`, userData);
  return response.data;
};

// Delete user (Admin only)
export const deleteUser = async (userId) => {
  const response = await api.delete(`/users/${userId}`);
  return response.data;
};
